import { render, staticRenderFns } from "./integration-card.vue?vue&type=template&id=e77a662c&scoped=true"
import script from "./integration-card.vue?vue&type=script&lang=js"
export * from "./integration-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e77a662c",
  null
  
)

export default component.exports